exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label_forgot[data-v-19034a15] {\n  font-size: 13px;\n  line-height: 13px;\n  padding: 0;\n  cursor: pointer;\n}\n.label_forgot[data-v-19034a15]:hover {\n  text-decoration: underline;\n}", ""]);

// exports
